import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import {useCurrentApp} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import {useCanViewInsights} from "crqlar-react-common/dist/utils/hooks/insights/useCanViewInsights";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {useParams} from "react-router-dom";
import type {TabRoute} from "../layout/PageShell";
import {PageShell} from "../layout/PageShell";
import DailyListCrm from "../dailyLists/DailyListCrm";
import CrmDemographicsInsightsTab from "../insights/CrmDemographicsInsightsTab";
import CrmInsightsTab from "../insights/CrmInsightsTab";
import CrmGuestList from "./CrmGuestList";

export default function Crm() {
    const {t} = useLocalize();
    const {appId: routeAppId} = useParams<"appId">();
    const currentAppId = useCurrentApp()?.id;
    const appId = routeAppId ?? currentAppId;
    const {canViewInsights} = useCanViewInsights();

    const tabs: TabRoute[] = [
        {
            path: `/crm/daily/${appId}`,
            label: t("Daily List"),
            render: () => <DailyListCrm/>,
        },
        {
            path: `/crm/guestList/${appId}`,
            label: t("Guest list"),
            render: () => <CrmGuestList/>,
        },
        // Both read the same guest base, so both follow the rule the API enforces on the insights
        // endpoints - Demographics included, since its endpoints are guarded the same way.
        ...(canViewInsights
            ? [
                {
                    path: `/crm/insights/${appId}`,
                    label: t("Insights"),
                    render: () => <CrmInsightsTab/>,
                },
                {
                    path: `/crm/demographics/${appId}`,
                    label: t("Demographics"),
                    render: () => <CrmDemographicsInsightsTab/>,
                },
            ]
            : []),
    ];

    return (
        <PageShell
            icon={<PeopleAltIcon fontSize="inherit"/>}
            title="CRM"
            documentTitle="CRM"
            tabs={tabs}
        />
    );
}
